export enum ActivityType {
    RequestForQuote = 'RequestForQuote',
    InformationRequested = 'InformationRequested',
    AddedManually = 'AddedManually',
    AddedAsIncumbent = 'AddedAsIncumbent',
    MarketDeclined = 'MarketDeclined',
    QuoteNotAccepted = 'QuoteNotAccepted',
    QuoteAttached = 'QuoteAttached',
    BinderAttached = 'BinderAttached',
    PolicyIssued = 'PolicyIssued',
    QuoteRemoved = 'QuoteRemoved',
    QuoteUpdated = 'QuoteUpdated',
    BinderRemoved = 'BinderRemoved',
    BinderUpdated = 'BinderUpdated',
    PolicyRemoved = 'PolicyRemoved',
    PolicyUpdated = 'PolicyUpdated',
    BinderCorrection = 'BinderCorrection',
    PolicyCorrection = 'PolicyCorrection',
    BindRequest = 'BindRequest',
    PolicyRequested = 'PolicyRequested',
    MarketEmailSent = 'MarketEmailSent',
    CustomerEmailSent = 'CustomerEmailSent',
    InsuredEmailSent = 'InsuredEmailSent',
    ProposalSent = 'ProposalSent',
    MarketingReportSent = 'MarketingReportSent',
    InformationRequestSent = 'InformationRequestSent',
    SubmissionCreated = 'SubmissionCreated',
    SubmissionUpdated = 'SubmissionUpdated',
    ProposalUpdated = 'ProposalUpdated',
    CustomerEmailReceived = 'CustomerEmailReceived',
    ArfRequest = 'ArfRequest',
    ArfSent = 'ArfSent',
    MarketEmailReceived = 'MarketEmailReceived',
    SubmissionStatusUpdated = 'SubmissionStatusUpdated',
    QuoteIndication = 'QuoteIndication',
    SolicitationEmailSent = 'SolicitationEmailSent',
}
